import React from 'react';
import { View, StyleSheet, Dimensions } from 'react-native';
import { SwiperFlatList } from 'react-native-swiper-flatlist';

const { width, height } = Dimensions.get('window');

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

interface Props {
  setWidth?: (width: number) => void;
  children?: React.ReactNode;
}

const SwipedView: React.FC<Props> = ({ setWidth, children }) => {
  const [layoutDone, setLayoutDone] = React.useState(false);
  const viewSize = React.useRef<{ width: number; height: number }>({
    width,
    height,
  });

  return (
    <View
      style={styles.container}
      onLayout={(event) => {
        const { width, height } = event.nativeEvent.layout;
        viewSize.current = { width, height };
        console.log('viewSize', viewSize.current);
        setLayoutDone(true);
        setWidth?.(width);
      }}
    >
      {layoutDone && (
        <SwiperFlatList
          index={0}
          showPagination
          disableGesture={true}
          vertical={false}
          style={{
            width: viewSize.current.width,
            // height: viewSize.current.height,
          }}
        >
          {children}
        </SwiperFlatList>
      )}
    </View>
  );
};

export default SwipedView;
